import _import from './config'
export default {
    path: 'workbench',
    component: {
        template: '<router-view :key="$route.fullPath"/>'
    },
    name: 'workbench',
    redirect: '/workbench/console',
    children: [
        {
            path: 'console',
            component: _import('workbench/index'),
            name: 'consoleIndex',
            meta: {
                auth: true,
            }
        }, {
            path: 'finereport/:menu',
            component:  _import('workbench/report/FineReport'),
            name: 'finereport',
            meta: {
                auth: true,
            }
        }, {
            path: 'report',
            component: {
                template: '<router-view :key="$route.fullPath"/>'
            },
            name: 'report',
            redirect: '/workbench/report/school',
            children: [
                {
                    path: 'school',
                    component: _import('workbench/report/FineReport'),
                    name: 'finereport1',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'comprehensive',
                    component: {
                        template: '<router-view :key="$route.fullPath"/>'
                    },
                    name: 'comprehensive',
                    children: [
                        {
                            path: 'branch',
                            component: _import('workbench/report/comprehensive/branchAchievement'),
                            name: 'comprehensivebranch',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'school',
                            component: _import('workbench/report/comprehensive/schoolAchievement'),
                            name: 'comprehensiveschool',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'branchrate',
                            component: _import('workbench/report/comprehensive/branchCompleteRate'),
                            name: 'branchrate',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'schoolrate',
                            component: _import('workbench/report/comprehensive/schoolCompleteRate'),
                            name: 'schoolrate',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'schoolstudent',
                            component: _import('workbench/report/comprehensive/schoolStudent'),
                            name: 'schoolstudent',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'signcompare',
                            component: _import('workbench/report/comprehensive/SigningCompare'),
                            name: 'signcompare',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'incomecompare',
                            component: _import('workbench/report/comprehensive/classIncomCompare'),
                            name: 'incomecompare',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'schoolclassprice',
                            component: _import('workbench/report/comprehensive/schoolClassPrice'),
                            name: 'schoolclassprice',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'memberspread',
                            component: _import('workbench/report/comprehensive/schoolMemberSpread'),
                            name: 'memberspread',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'realtimebranch',
                            component: _import('workbench/report/realtime/branch-achievement-real'),
                            name: 'realtimebranch',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'realtimeschool',
                            component: _import('workbench/report/realtime/school-achievement-real'),
                            name: 'realtimeschool',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'realtimebranchrate',
                            component: _import('workbench/report/realtime/branch-completerate-real'),
                            name: 'realtimebranchrate',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'realtimeschoolrate',
                            component: _import('workbench/report/realtime/school-completerate-real'),
                            name: 'realtimeschoolrate',
                            meta: {
                                auth: true
                            }
                        }
                    ]
                }, {
                    path: 'consultative',
                    component: {
                        template: '<router-view :key="$route.fullPath"/>'
                    },
                    name: 'consultative',
                    children: [
                        {
                            path: 'scoreearly',
                            component: _import('workbench/report/consultative/schoolScoreEarly'),
                            name: 'scoreearly',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'scoreconsultant',
                            component: _import('workbench/report/consultative/schoolScoreConsultant'),
                            name: 'scoreconsultant',
                            meta: {
                                auth: true
                            }
                        }
                    ]
                }, {
                    path: 'schooladmin',
                    component: {
                        template: '<router-view :key="$route.fullPath"/>'
                    },
                    name: 'schooladmin',
                    children: [
                        {
                            path: 'scorelater',
                            component: _import('workbench/report/schooladmin/schoolScoreLater'),
                            name: 'scorelater',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'scorestudyadmin',
                            component: _import('workbench/report/schooladmin/studyAdminScore'),
                            name: 'scorestudyadmin',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'classstudyadmin',
                            component: _import('workbench/report/schooladmin/studyAdminClass'),
                            name: 'classstudyadmin',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'classstudent',
                            component: _import('workbench/report/schooladmin/studentClasses'),
                            name: 'classstudent',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'schoolmember',
                            component: _import('workbench/report/schooladmin/studentsOfSchool'),
                            name: 'schoolmember',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'studyadminmember',
                            component: _import('workbench/report/schooladmin/studyAdminMember'),
                            name: 'studyadminmember',
                            meta: {
                                auth: true
                            }
                        }
                    ]
                }, {
                    path: 'teaching',
                    component: {
                        template: '<router-view :key="$route.fullPath"/>'
                    },
                    name: 'teaching',
                    children: [
                        {
                            path: 'teachergradesub',
                            component: _import('workbench/report/teaching/teacherGradeSub'),
                            name: 'teachergradesub',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'teacherclasses',
                            component: _import('workbench/report/teaching/teacherClasses'),
                            name: 'teacherclasses',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'schoolclasssign',
                            component: _import('workbench/report/teaching/schoolClassSign'),
                            name: 'schoolclasssign',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'schoolteacherstay',
                            component: _import('workbench/report/teaching/schoolTeacherStay'),
                            name: 'schoolteacherstay',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'schoolclasssignall',
                            component: _import('workbench/report/teaching/schoolClassSignAll'),
                            name: 'schoolclasssignall',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'schoolclasscoeff',
                            component: _import('workbench/report/teaching/schoolClassCoeff'),
                            name: 'schoolclasscoeff',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'classtypeincome',
                            component: _import('workbench/report/teaching/classTypeIncome'),
                            name: 'classtypeincome',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'jdxkTimetable',
                            component: _import('workbench/report/teaching/jdxkTimetable'),
                            name: 'jdxkTimetable',
                            meta: {
                                auth: true
                            }
                        }
                    ]
                }, {
                    path: 'stafinance',
                    component: {
                        template: '<router-view :key="$route.fullPath"/>'
                    },
                    name: 'stafinance',
                    children: [
                        {
                            path: 'contracttype',
                            component: _import('workbench/report/finance/contractType'),
                            name: 'contracttype',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'advancereceive',
                            component: _import('workbench/report/finance/advanceReceive'),
                            name: 'advancereceive',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'selfenrollfinance',
                            component: _import('workbench/report/finance/selfEnrollFinance'),
                            name: 'selfenrollfinance',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'refundsummary',
                            component: _import('workbench/report/finance/refundSummary'),
                            name: 'refundsummary',
                            meta: {
                                auth: true
                            }
                        }
                    ]
                }, {
                    path: 'personal',
                    component: {
                        template: '<router-view :key="$route.fullPath"/>'
                    },
                    name: 'personal',
                    children: [
                        {
                            path: 'onevoneclass',
                            component: _import('workbench/report/personnel/oneVOneClass'),
                            name: 'onevoneclass',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'teamclass',
                            component: _import('workbench/report/personnel/teamClass'),
                            name: 'teamclass',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'subgroupclass',
                            component: _import('workbench/report/personnel/subGroupClass'),
                            name: 'subgroupclass',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'signearlylater',
                            component: _import('workbench/report/personnel/signEarlyLater'),
                            name: 'signearlylater',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'studyadminonevone',
                            component: _import('workbench/report/personnel/studyAdminOneVOne'),
                            name: 'studyadminonevone',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'studyadminteam',
                            component: _import('workbench/report/personnel/studyAdminTeam'),
                            name: 'studyadminteam',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'studyadminteamnormal',
                            component: _import('workbench/report/personnel/studyAdminTeamNormal'),
                            name: 'studyadminteamnormal',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'teamclassnormal',
                            component: _import('workbench/report/personnel/teamClassNormal'),
                            name: 'teamclassnormal',
                            meta: {
                                auth: true
                            }
                        }
                    ]
                }, {
                    path: 'channel',
                    component: {
                        template: '<router-view :key="$route.fullPath"/>'
                    },
                    name: 'stachannel',
                    children: [
                        {
                            path: 'campusresources',
                            component: _import('workbench/report/channel/campusResources'),
                            name: 'campusresources',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'branchresources',
                            component: _import('workbench/report/channel/branchResources'),
                            name: 'branchresources',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'marketresources',
                            component: _import('workbench/report/channel/marketResources'),
                            name: 'marketresources',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'graderesources',
                            component: _import('workbench/report/channel/gradeResources'),
                            name: 'graderesources',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'deptresources',
                            component: _import('workbench/report/channel/deptResources'),
                            name: 'deptresources',
                            meta: {
                                auth: true
                            }
                        }, {
                            path: 'communitystatistics',
                            component: _import('workbench/report/channel/communityStatistics'),
                            name: 'communitystatistics',
                            meta: {
                                auth: true
                            }
                        }
                    ]
                },
            ]
        }, {
            path: 'myQuestion',
            component: _import('system/else/question'),
            name: 'myQuestion',
            meta: {
                auth: true
            }
        }, {
            path: 'myApproval',
            component: _import('workbench/myApproval'),
            name: 'myApproval',
            meta: {
                auth: true
            }
        }, {
            path: 'mydepartment',
            component: _import('workbench/myDepartment'),
            name: 'mydepartment',
            meta: {
                auth: true
            }
        }, {
            path: 'benchindex',
            component: _import('workbench/userBench/benchIndex'),
            name: 'benchindex',
            meta: {
                auth: true
            }
        }, {
            path: 'community',
            component: _import('workbench/community/comuList'),
            name: 'community',
            meta: {
                auth: true
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/console.js